import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { hasRole } from '@/utils/auth';
import AuthModal from './AuthModal';

const ProtectedRoute = ({ children, requiredRole }) => {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const hasAccess = hasRole(requiredRole);

  useEffect(() => {
    if (!hasAccess) {
      setShowAuthModal(true);
    }
  }, [hasAccess]);

  if (!hasAccess) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Access Restricted</h2>
          <p className="text-gray-600 mb-6">You need to sign in to access this page.</p>
          <AuthModal 
            isOpen={showAuthModal} 
            onClose={() => {
              setShowAuthModal(false);
              window.location.href = '/';
            }}
            defaultTab="login"
            requiredRole={requiredRole}
          />
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
